<template>
	<p v-if="saleMessage" class="!m-0 !my-2.5 !p-0 text-xs font-normal text-orange-800">
		{{ saleMessage }}
	</p>
</template>
<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import { useProductStore } from '@stores'

const store = useProductStore()
const { selectedVariant } = storeToRefs(store)

const saleMessage = computed(() => selectedVariant.value?.saleMessage)
</script>
